<script lang="ts">
import { createEventDispatcher } from 'svelte';
import deepEqual from 'fast-deep-equal';
import type { Person } from '../api/types';
import store from '../store/person';
import Input from './Input.svelte';
import Button from './Button.svelte';
import FileList from './FileList.svelte';
import type { PersonRequest } from '../api/put';

export let person: Person | undefined;
let form: PersonRequest = {
    id: '',
    name: '',
    description: '',
    files: []
};
let prev: Person;
let locked = false;
let updated = false;
const dispatch = createEventDispatcher();

$: clone(person);
$: updated = !deepEqual(form, person);

function clone(data: Person | undefined): void {
    // Обходим слишком умную систему Svelte построения зависимостей для инвалидации.
    // Логичнее было бы на уровне компонента написать
    // $: form = clone(course)
    // Однако в этом случае Svelte зачем-то добавит в биндингах инвалидацию
    // объекта `course`, что в итоге приведёт к новому циклу обновления `form`
    // и перетрёт данные.
    // В такой реализации инвалидация будет работать правильно
    if (prev !== data) {
        form = {
            name: '',
            description: '',
            ...data,
            files: []
        };
        prev = data;
    }
}

async function onSubmit() {
    if (!form.id) {
        // Создаём нового
        person = await store.createPerson(form);
        dispatch('create', person);
    } else {
        person = await store.updatePerson(form);
        dispatch('update', person);
    }
}

function onReset() {
    clone(person);
}

function onUploadEnd(evt: CustomEvent) {
    locked = false;
    form.files = evt.detail;
}

function onDelete(evt: CustomEvent) {
    form.files = evt.detail;
}
</script>
<style lang="scss">
form {
    :global(.input:not(:first-of-type)) {
        margin-top: 24px;
    }
}
</style>
<form action="/" on:submit|preventDefault={onSubmit} on:reset|preventDefault={onReset}>
    <Input name="name" bind:value={form.name}>Имя</Input>
    <Input name="description" type="textarea" bind:value={form.description}>Описание</Input>

    <h2>Фото лектора и материалы</h2>
    <FileList files={person ? person.files : []}
        on:upload-start={() => locked = true}
        on:upload-end={onUploadEnd}
        on:delete={onDelete} />

    <footer>
        <Button type="reset">Сбросить</Button>
        <Button role="primary" type="submit" disabled={!locked && !updated}>Сохранить данные</Button>
    </footer>
</form>
